import {
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Icon,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { FaMoneyBillWave, FaPlayCircle, FaCog } from "react-icons/fa";

import Payouts from "../tabpanels/Payouts";
import PayoutRun from "../tabpanels/PayoutRun";
import Configurations from "../tabpanels/Configurations";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import { onlyUAdmins } from "utils/accessLevels";
// import { useRecoilValue } from "recoil";

const PayoutTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  // Sync active tab from URL query param
  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam === "payrun") {
      setActiveTabIndex(1);
    } else if (tabParam === "configuration") {
      setActiveTabIndex(2);
    } else {
      setActiveTabIndex(0);
    }
  }, [searchParams]);

  const handleTabChange = (index) => {
    const tabName =
      index === 1 ? "payrun" : index === 2 ? "configuration" : "payouts";
    setSearchParams({ tab: tabName });
  };

  return (
    <Flex direction="column" w="100%">
      <Tabs
        variant="unstyled"
        colorScheme="orange"
        isLazy={true}
        index={activeTabIndex}
        onChange={handleTabChange}
      >
        <TabList
          gap={4}
          px={1}
          py={2}
          bg="rgba(255, 255, 255, 0.6)"
          backdropFilter="blur(12px)"
          borderRadius="xl"
          border="1px solid rgba(245, 125, 54, 0.15)"
          position="relative"
          overflow="hidden"
          mb={6}
          _before={{
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "100%",
            zIndex: 0,
            pointerEvents: "none",
          }}
        >
          {/* <Tab _focus={{boxShadow: "none"}}>Unsettled Transactions</Tab> */}
          <Tab
            _focus={{ boxShadow: "none" }}
            borderRadius="lg"
            px={4}
            py={2}
            fontWeight="500"
            color="gray.600"
            position="relative"
            zIndex="1"
            _selected={{
              bg: "rgba(245, 125, 54, 0.15)",
              color: "#f57d36",
              fontWeight: "600",
              boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
            }}
            _hover={{
              bg: "rgba(245, 125, 54, 0.08)",
              color: "#f57d36",
            }}
          >
            <Flex align="center" gap={2}>
              <Icon as={FaMoneyBillWave} boxSize={4} />
              <Text>Payouts</Text>
            </Flex>
          </Tab>
          <RoleBasedRender roles={onlyUAdmins}>
            <Tab
              _focus={{ boxShadow: "none" }}
              borderRadius="lg"
              px={4}
              py={2}
              fontWeight="500"
              color="gray.600"
              position="relative"
              zIndex="1"
              _selected={{
                bg: "rgba(245, 125, 54, 0.15)",
                color: "#f57d36",
                fontWeight: "600",
                boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
              }}
              _hover={{
                bg: "rgba(245, 125, 54, 0.08)",
                color: "#f57d36",
              }}
            >
              <Flex align="center" gap={2}>
                <Icon as={FaPlayCircle} boxSize={4} />
                <Text>Payrun</Text>
              </Flex>
            </Tab>
          </RoleBasedRender>
          <RoleBasedRender roles={onlyUAdmins}>
            <Tab
              _focus={{ boxShadow: "none" }}
              borderRadius="lg"
              px={4}
              py={2}
              fontWeight="500"
              color="gray.600"
              position="relative"
              zIndex="1"
              _selected={{
                bg: "rgba(245, 125, 54, 0.15)",
                color: "#f57d36",
                fontWeight: "600",
                boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
              }}
              _hover={{
                bg: "rgba(245, 125, 54, 0.08)",
                color: "#f57d36",
              }}
            >
              <Flex align="center" gap={2}>
                <Icon as={FaCog} boxSize={4} />
                <Text>Configurations</Text>
              </Flex>
            </Tab>
          </RoleBasedRender>
        </TabList>

        <TabPanels>
          {/* <TabPanel
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Settlement type="amount" />
            <UnsettledTransactions />
          </TabPanel> */}
          <TabPanel p={0}>
            <Payouts />
          </TabPanel>
          <RoleBasedRender roles={onlyUAdmins}>
            <TabPanel
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              p={0}
            >
              <PayoutRun />
            </TabPanel>
          </RoleBasedRender>
          <RoleBasedRender roles={onlyUAdmins}>
            <TabPanel p={0}>
              <Configurations />
            </TabPanel>
          </RoleBasedRender>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};

export default PayoutTabs;
